import type { CSSProperties, ReactNode } from "react";

import styles from "./RepoAvatar.module.css";
import { cx } from "../lib/cx";

export type RepoAvatarProps = {
  readonly children?: ReactNode;
  readonly className?: string;
  readonly org: string;
  readonly radius?: number;
  readonly size?: number;
  readonly style?: CSSProperties;
};

/** Rounded-square avatar showing an org initial (or custom children). */
export const RepoAvatar = ({
  children,
  className,
  org,
  radius,
  size = 32,
  style,
}: RepoAvatarProps) => (
  <div
    className={cx(styles.avatar, className)}
    style={{
      borderRadius: radius ?? Math.round(size / 4),
      fontSize: size <= 22 ? 10.5 : size >= 34 ? 13 : 12,
      height: size,
      width: size,
      ...style,
    }}
  >
    {children ?? org.charAt(0).toUpperCase()}
  </div>
);
